import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
export function setupPinia() {
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedstate);
    if (window?.paymentLinksEditorApp) {
        window.paymentLinksEditorApp.use(pinia);
    }
}
